import React from "react";
import DataGrid from "../components/DataGrid/DataGrid"; // Assume DataGrid is in the same directory
import { Delete, Edit, Visibility } from "@mui/icons-material";
import RowContextMenu from "../components/DataGrid/RowContextMenu";

const App = () => {
  const columns = [
    { field: "id", headerName: "ID", align: "left", filterable: true, size: '80px', hiddenFilterOptions: true },
    { field: "name", headerName: "Name", align: "left", filterable: true, permanent: true },
    { field: "cost", headerName: "Cost", align: "right", filterable: true },
    { field: "created_at", headerName: "Creation", align: "left", filterable: true, type: "date" },
    { field: "price", headerName: "Price", align: "left", invisible: true },
  ];

  // Define actions outside the RowContextMenu
  const rowActions = [
    { name: "View", icon: <Visibility fontSize="small" />, visible:false, onClick: (row) => console.log("Viewing row:", row) },
    { name: "Edit", icon: <Edit fontSize="small" />, onClick: (row) => console.log("Editing row:", row) },
    { name: "Delete", icon: <Delete fontSize="small" style={{ color: 'red' }} />,  onClick: (row) => console.log("Deleting row:", row)},
];

const CustomRowContextMenu = (props) => {
    return <RowContextMenu {...props} actions={rowActions} />
}

  return (
    <div>
      <h1>Data Grid Example</h1>
      <DataGrid table={'products'} columns={columns} RowContextMenu={CustomRowContextMenu} exportFileName='TEST' />
    </div>
  );
};

export default App;
